import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://itghar-back.onrender.com/api/v1",
  }),

  endpoints: (builder) => ({}),
});

export default api;
